import DialogsStyles from '@Styles/dialogs.scss';
import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ModalBody from '@Components/ModalComponents/ModalBody';
import ModalHeader from '@Components/ModalComponents/ModalHeader';
import FilesApi from '@Data/files/Api';
import { IFolder } from '@Data/folders/Interfaces';
import { foldersState, visibleFoldersState } from '@Data/folders/Reducer';
import { ProjectActionType } from '@Data/projects/ProjectActionTypes';
import { ConnectDepartmentDialog } from '../ConnectDept/ConnectDepartmentDialog';
import CreateSubsetDialogue from '../CreateSubset/CreateSubsetDialogue';
import FileUploadDialogue from '../FileUpload/FileUploadDialogue';
import ProcessesDialogue from '../Processes/ProcessesDialogue';

interface IProjectModalDialogProps {
    isOpen: boolean;
    onCancel: () => void;
    type: ProjectActionType;
    projectId: number;
    teamId?: string;
    onComplete: () => void;
    selectedFolder?: IFolder;
}

const ProjectModalDialog = (props: IProjectModalDialogProps) => {
    const {
        isOpen,
        onCancel,
        type,
        projectId,
        onComplete,
        selectedFolder,
        teamId,
    } = props;

    const [title, setTitle] = useState<string>('');
    const [dialogId, setDialogId] = useState<string>('');
    const [innerComponent, setInnerComponent] = useState<JSX.Element>(null);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [footerComponent, setFooterComponent] = useState<any>(null);

    const visibleFolders = useSelector(visibleFoldersState);

    useEffect(() => {
        if (!isOpen) {
            setIsSubmitting(false);
        }
    }, [isOpen]);

    const onFileUploadCancel = () => {
        FilesApi.resetState();
        handleCancel();
    };

    const handleCancel = () => {
        onCancel();
        setFooterComponent(null);
    };

    useEffect(() => {
        switch (type) {
            case ProjectActionType.UPLOAD_FILE:
                setTitle('Upload Project Data');
                setDialogId('dialogUploadProjectData');
                setInnerComponent(
                    <FileUploadDialogue
                        projectId={projectId}
                        onCancel={onFileUploadCancel}
                        setCancelDisabled={setIsSubmitting}
                        onComplete={onComplete}
                        setFooter={setFooterComponent}
                    />
                );
                break;
            case ProjectActionType.OPEN_PROCESS:
                setTitle(`Processing Console - ${selectedFolder.folder_name}`);
                setDialogId('dialogProcess');
                setInnerComponent(
                    <ProcessesDialogue
                        projectId={projectId}
                        onCancel={handleCancel}
                        setCancelDisabled={setIsSubmitting}
                        selectedFolder={selectedFolder}
                        onComplete={onComplete}
                        setFooter={setFooterComponent}
                    />
                );
                break;
            case ProjectActionType.CREATE_SUBSET:
                setTitle(
                    `Create Folder Subset - ${selectedFolder.folder_name}`
                );
                setDialogId('dialogCreateFolderSubset');
                setInnerComponent(
                    <CreateSubsetDialogue
                        projectId={projectId}
                        onCancel={handleCancel}
                        onComplete={onComplete}
                        setCancelDisabled={setIsSubmitting}
                        selectedFolder={selectedFolder}
                        setFooter={setFooterComponent}
                    />
                );
                break;
            case ProjectActionType.CONNECT_DEPT:
                setTitle(`Connect Department`);
                setDialogId('dialogConnectDepartment');
                setInnerComponent(
                    <ConnectDepartmentDialog
                        projectId={projectId}
                        onCancel={handleCancel}
                        onComplete={onComplete}
                        setCancelDisabled={setIsSubmitting}
                        setFooter={setFooterComponent}
                        teamId={teamId}
                    />
                );
                break;
        }
    }, [type]);

    return (
        <Dialog
            id={dialogId}
            open={isOpen}
            maxWidth="lg"
            sx={{
                ['& .MuiDialog-container']: {
                    alignItems: 'flex-start',
                    marginTop: '5rem',
                    // maxHeight: '80%'
                },
            }}
        >
            <ModalHeader
                id="project-modal-dialog-header"
                title={title}
                onCancel={onCancel}
                isCancelDisabled={isSubmitting}
            />
            <ModalBody>
                <div className={DialogsStyles.processModalComponentContainer}>
                    {innerComponent}
                </div>
            </ModalBody>
            <div>{footerComponent}</div>
        </Dialog>
    );
};

export default ProjectModalDialog;
